import { DropdownOption } from "core/models";

export const minLength = 0.5; // Minimum subtitle length seconds
export const defaultLength = 2; // Subtitle length in seconds
export const emptyState = "No subtitles yet…";

export const languageOptions: DropdownOption[] = [
    {
        id: 1,
        title: "Dutch",
        value: "Nl",
    },
    {
        id: 2,
        title: "English",
        value: "En",
    },
    {
        id: 3,
        title: "German",
        value: "De",
    },
    {
        id: 4,
        title: "Spanish",
        value: "Es",
    },
];
